"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResizeGroup_base_1 = require("./ResizeGroup.base");
exports.ResizeGroup = ResizeGroup_base_1.ResizeGroupBase;
//# sourceMappingURL=ResizeGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ResizeGroup/ResizeGroup.js
// module id = 742
// module chunks = 0